export default __webpack_public_path__ + "static/media/space_part8.9a538877.png";